import { useFormContext } from 'react-hook-form'

import { TField } from '../../types'
import { IsFieldDisabled, IsFieldRequired } from '../field-row'

/** `disabled` includes the form-level `disabled`; a disabled field is never required. */
export const useFieldState = (rowField: TField) => {
    const formDisabled = useFormContext()?.formState.disabled ?? false

    const disabled = IsFieldDisabled(rowField) || formDisabled
    const required = IsFieldRequired(rowField) && !disabled

    return { disabled, required }
}
